import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className='footer'>
      &copy; 2025 H.N. Fisher | All rights reserved.
    </div>
  )
}
